import React, { useState } from 'react';
import {
  Briefcase,
  Calendar,
  MapPin,
  ExternalLink,
  GraduationCap,
  Award,
  Download,
  ChevronRight
} from 'lucide-react';

const Experience = () => {
  const [activeTab, setActiveTab] = useState('experience');

  const experiences = [
    {
      id: 1,
      company: 'Synacore Tech',
      position: 'Founder & CTO',
      type: 'Full-time',
      location: 'Hyderabad, Telangana, India',
      period: 'Jun 2025 - Present · 2 mos',
      description: 'As a Tech Company we Craft revolutionary digital experiences, and unparalleled innovation.',
      achievements: [],
      technologies: [],
      companyUrl: '' // Assuming no external URL provided for Synacore Tech
    },
    {
      id: 2,
      company: 'Dotnet Learners House & Global AI Secunderabad',
      position: 'Organiser',
      type: 'Full-time',
      location: 'Hyderabad, Telangana, India',
      period: 'Jun 2025 - Present · 2 mos',
      description: 'Our Community Aims for Collaborative Learning With some Amazing Tech Events',
      achievements: [],
      technologies: [],
      companyUrl: '' // Assuming no external URL provided for Swamy's Tech Skills Academy
    },
    {
      id: 3,
      company: 'Google Developer Groups on campus IFHE',
      position: 'Event Management Lead',
      type: 'Full-time',
      location: 'India',
      period: 'Sep 2024 - Jun 2025 · 10 mos',
      description: '', // Main description is within achievements for this one
      achievements: [
        'Organized and managed technical events, hackathons, workshops, and meetups to foster learning and community engagement around Google technologies and other trending innovations.',
        'Supervised a team of volunteers, assigning roles and ensuring smooth execution of events. Acted as the main point of communication between the organizing team and stakeholders.',
        'Engaged with students and professionals to build a thriving on-campus developer community, promoting Google’s vision of inclusive learning.',
        'Designed promotional strategies using social media, email campaigns, and offline outreach to maximize participation in events.',
        'Handled venue booking, resource allocation, budget planning, and vendor coordination for events.',
        'Collaborated with external speakers, companies, and industry experts to bring valuable learning opportunities to the community.'
      ],
      technologies: ['Event Management', 'Community Building', 'Team Leadership'],
      companyUrl: '' // Assuming no external URL for Google Developer Groups
    },
    {
      id: 4,
      company: 'CODEPLAYERS Business System Private Limited',
      position: 'ERP web development Intern',
      type: 'Internship',
      location: 'India · Remote',
      period: 'Jun 2024 - Jul 2024 · 2 mos',
      description: 'Seeking a Software Engineering, Web Developer, Full Stack Developer, Ui-Ux designer Internship role to leverage my programming skills and problem-solving abilities in developing innovative software solutions. Eager to contribute to cutting-edge technology projects while learning industry best practices in a collaborative team environment that empowers users and organizations globally.',
      achievements: [
        'Developed 3 major projects: Company website redesign, Infinity X: PWA-based ERP platform, and Industrial ERP for Sunil Sponze.',
        'Contributed to a Student Management System - Web-based system for student/course data management with features like user authentication, grade tracking, and attendance.',
        'Responsible for database design & frontend development for the Student Management System.',
        'Gained experience in Full-stack development & UI/UX design.'
      ],
      technologies: ['MySQL', 'PHP', 'Bootstrap', 'React', 'REST APIs', 'VS Code', 'GitHub', 'User Experience Design (UED)', 'Progressive Web Applications (PWAs)'],
      companyUrl: 'https://drive.google.com/drive/folders/1dRTzluV-vCbuEjvIWTxeQEO3UGn6aDLC?usp=sharing' // Internship Proof of Work URL
    }
  ];

  const education = [
    {
      id: 1,
      institution: 'Icfai Tech School',
      degree: 'Bachelor of Technology (B.Tech), Computer Science Engineering',
      specialization: '',
      location: '',
      period: 'Aug 2022 - Aug 2026',
      gpa: '8.36 CGPA',
      description: 'Secured a CGPA of 8.36 over three years of graduation.',
      achievements: []
    },
    {
      id: 2,
      institution: 'Narayana Junior college',
      degree: 'Intermediate',
      specialization: '',
      location: '',
      period: 'Sep 2020 - Jun 2022',
      gpa: '9.29 Percentage',
      description: 'Secured a Percentage of 9.29.',
      achievements: []
    },
    {
      id: 3,
      institution: 'Sahiti vidya niketan High School',
      degree: 'Schooling',
      specialization: '',
      location: '',
      period: 'Sep 2007 - May 2020',
      gpa: '100% Merit Score',
      description: 'Achieved a merit score of 100%.',
      achievements: []
    }
  ];

  const certifications = [
    {
      id: 1,
      name: 'GitHub Copilot Ask/Edit/Agent, Prompt Engg, Vibe Coding, AI Applications - Attendee',
      issuer: 'Global AI Community',
      date: 'Jul 2025',
      credentialId: 'b7b53bd6-97c0-4e59-a059-e4c8138a87f4',
      url: 'https://globalai.community/badges/b7b53bd6-97c0-4e59-a059-e4c8138a87f4/'
    },
    {
      id: 2,
      name: 'AI Agents, Prompt Engineering, GitHub Copilot',
      issuer: 'Global AI Community',
      date: 'Jun 2025',
      credentialId: 'f5f88444-2b30-4e62-af65-850e55cb4503',
      url: 'https://globalai.community/badges/f5f88444-2b30-4e62-af65-850e55cb4503/'
    },
    {
      id: 3,
      name: 'AWS Certifications - AWS Cloud Foundations',
      issuer: 'Amazon Web Services (AWS) / Credly',
      date: 'Apr 2025',
      credentialId: 'bd7880ac-67bf-41c5-a63c-a63c-b274d36fc436',
      url: 'https://www.credly.com/badges/bd7880ac-67bf-41c5-a63c-b274d36fc436/public_url'
    },
    {
      id: 4,
      name: 'Udemy Certification - Full Stack Development',
      issuer: 'Udemy',
      date: 'Apr 2025',
      credentialId: 'UC-e3c0841f-5381-484f-9e72-79a8c072e62b',
      url: 'https://www.udemy.com/certificate/UC-e3c0841f-5381-484f-9e72-79a8c072e62b/'
    },
    {
      id: 5,
      name: 'AWS GenAI Hackathon Runners Up',
      issuer: 'AWS Party Rock',
      date: 'August 2024',
      credentialId: null, // No specific credential ID provided for this event
      url: 'https://drive.google.com/file/d/1xRGDGPQz6rpm3tabM1D1Ri_X52HVhagF/view?usp=drive_link', // Proof of work URL
      description: 'Built and presented an AI-powered Food Recommendation System based on available ingredients using AWS Party Rock.'
    },
    {
      id: 6,
      name: 'TCS iON Career Edge - Young Professional',
      issuer: 'TCS iON',
      date: 'Nov 2023 - Dec 2023',
      credentialId: null, // No specific credential ID provided
      url: 'https://drive.google.com/drive/folders/1xCrn_8Y-gID1yIPR6O_U2iXd4ztWEKFW?usp=sharing', // Proof of work URL
      description: 'Completed a certification course focusing on career development, professional skills, communication, and leadership, including modules on Workflow Optimization and teamwork, with a final grade of 85%.'
    }
  ];

  const tabs = [
    { id: 'experience', label: 'Experience', icon: Briefcase },
    { id: 'education', label: 'Education', icon: GraduationCap },
    { id: 'certifications', label: 'Certifications', icon: Award }
  ];

  const TimelineItem = ({ item, type }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
      <div style={{
        position: 'relative',
        display: 'flex',
        gap: '1.5rem',
        paddingBottom: '2rem',
        borderLeft: '2px solid rgba(150, 199, 185, 0.3)',
        paddingLeft: '1.5rem',
        marginLeft: '1rem'
      }}>
        {/* Timeline Dot */}
        <div style={{
          position: 'absolute',
          left: '-9px',
          top: '0',
          width: '16px',
          height: '16px',
          backgroundColor: '#96C7B9',
          borderRadius: '50%',
          border: '4px solid #FFFFFF',
          boxShadow: '0 0 0 4px rgba(150, 199, 185, 0.2)'
        }} />

        {/* Content */}
        <div style={{ flex: 1 }}>
          <div style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            padding: '1.5rem',
            border: '2px solid rgba(150, 199, 185, 0.3)',
            boxShadow: '0 4px 15px rgba(150, 199, 185, 0.1)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(150, 199, 185, 0.2)';
            e.currentTarget.style.borderColor = 'rgba(150, 199, 185, 0.5)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(150, 199, 185, 0.1)';
            e.currentTarget.style.borderColor = 'rgba(150, 199, 185, 0.3)';
          }}>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              marginBottom: '1rem'
            }}>
              <div>
                <h3 style={{
                  fontFamily: 'Comfortaa, sans-serif',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  color: '#2C3E50',
                  marginBottom: '0.5rem'
                }}>
                  {type === 'experience' ? item.position : item.degree}
                </h3>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  color: '#96C7B9',
                  marginBottom: '0.5rem'
                }}>
                  <span style={{ fontWeight: '500' }}>
                    {type === 'experience' ? item.company : item.institution}
                  </span>
                  {item.companyUrl && (
                    <a
                      href={item.companyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#546C81',
                        transition: 'color 0.3s ease'
                      }}
                      onMouseOver={(e) => e.target.style.color = '#96C7B9'}
                      onMouseOut={(e) => e.target.style.color = '#546C81'}
                    >
                      <ExternalLink size={16} />
                    </a>
                  )}
                </div>
              </div>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontSize: '0.9rem',
                  color: '#546C81'
                }}>
                  <Calendar size={14} />
                  {item.period}
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontSize: '0.9rem',
                  color: '#546C81'
                }}>
                  <MapPin size={14} />
                  {item.location}
                </div>
              </div>
            </div>

            {type === 'experience' && item.type && (
              <div style={{ marginBottom: '1rem' }}>
                <span style={{
                  display: 'inline-block',
                  padding: '0.25rem 0.5rem',
                  backgroundColor: 'rgba(150, 199, 185, 0.1)',
                  border: '1px solid rgba(150, 199, 185, 0.3)',
                  borderRadius: '6px',
                  fontSize: '0.75rem',
                  color: '#96C7B9',
                  fontWeight: '500'
                }}>
                  {item.type}
                </span>
              </div>
            )}

            {type === 'education' && item.gpa && (
              <div style={{ marginBottom: '1rem' }}>
                <span style={{ fontSize: '0.9rem', color: '#546C81' }}>
                  {item.gpa.includes('CGPA') ? `CGPA: ${item.gpa.split(' ')[0]}` : `Percentage: ${item.gpa.split(' ')[0]}`}
                </span>
              </div>
            )}

            <p style={{
              fontSize: '1rem',
              color: '#546C81',
              lineHeight: '1.6',
              marginBottom: '1rem'
            }}>
              {item.description}
            </p>

            {item.achievements && item.achievements.length > 0 && (
              <div style={{ marginBottom: '1rem' }}>
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    color: '#96C7B9',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = '#7BB5A7';
                    e.target.style.transform = 'translateX(4px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = '#96C7B9';
                    e.target.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }}>
                    <ChevronRight size={16} />
                  </div>
                  {isExpanded ? 'Hide' : 'Show'} Key Achievements
                </button>

                <div style={{
                  overflow: 'hidden',
                  height: isExpanded ? 'auto' : '0',
                  opacity: isExpanded ? 1 : 0,
                  transition: 'all 0.3s ease'
                }}>
                  <ul style={{
                    marginTop: '0.75rem',
                    paddingLeft: '0',
                    listStyle: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                  }}>
                    {item.achievements.map((achievement, i) => (
                      <li
                        key={i}
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '0.5rem',
                          fontSize: '0.9rem',
                          color: '#546C81'
                        }}
                      >
                        <div style={{
                          width: '6px',
                          height: '6px',
                          backgroundColor: '#96C7B9',
                          borderRadius: '50%',
                          marginTop: '0.5rem',
                          flexShrink: 0
                        }} />
                        {achievement}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {item.technologies && item.technologies.length > 0 && (
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem'
              }}>
                {item.technologies.map((tech, i) => (
                  <span
                    key={tech}
                    style={{
                      padding: '0.25rem 0.5rem',
                      backgroundColor: 'rgba(150, 199, 185, 0.1)',
                      border: '1px solid rgba(150, 199, 185, 0.3)',
                      borderRadius: '6px',
                      fontSize: '0.75rem',
                      color: '#546C81',
                      fontWeight: '500'
                    }}
                  >
                    {tech}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const CertificationCard = ({ cert }) => (
    <div style={{
      backgroundColor: '#FFFFFF',
      borderRadius: '12px',
      padding: '1.5rem',
      border: '2px solid rgba(150, 199, 185, 0.3)',
      boxShadow: '0 4px 15px rgba(150, 199, 185, 0.1)',
      transition: 'all 0.3s ease'
    }}
    onMouseOver={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 8px 25px rgba(150, 199, 185, 0.2)';
      e.currentTarget.style.borderColor = 'rgba(150, 199, 185, 0.5)';
    }}
    onMouseOut={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 4px 15px rgba(150, 199, 185, 0.1)';
      e.currentTarget.style.borderColor = 'rgba(150, 199, 185, 0.3)';
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1rem'
      }}>
        <h3 style={{
          fontFamily: 'Comfortaa, sans-serif',
          fontSize: '1.2rem',
          fontWeight: '600',
          color: '#2C3E50'
        }}>
          {cert.name}
        </h3>
        {cert.url && (
          <a
            href={cert.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#546C81',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.color = '#96C7B9';
              e.target.style.transform = 'scale(1.1)';
            }}
            onMouseOut={(e) => {
              e.target.style.color = '#546C81';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <ExternalLink size={18} />
          </a>
        )}
      </div>
      <p style={{
        color: '#96C7B9',
        fontWeight: '500',
        marginBottom: '0.5rem'
      }}>
        {cert.issuer}
      </p>
      {cert.description && ( // Display description if available
        <p style={{ fontSize: '0.9rem', color: '#546C81', lineHeight: '1.4', marginBottom: '0.5rem' }}>
          {cert.description}
        </p>
      )}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '0.9rem',
        color: '#546C81'
      }}>
        <span>Issued: {cert.date}</span>
        {cert.credentialId && <span>ID: {cert.credentialId}</span>}
      </div>
    </div>
  );

  return (
    <section id="experience" style={{
      padding: '5rem 0',
      backgroundColor: '#D1F0E0',
      position: 'relative'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>

        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <p style={{
            color: '#96C7B9',
            fontSize: '0.9rem',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            marginBottom: '1rem'
          }}>
            My Journey
          </p>
          <h2 style={{
            fontFamily: 'Comfortaa, sans-serif',
            fontSize: 'clamp(2rem, 6vw, 3rem)',
            fontWeight: '600',
            color: '#2C3E50',
            marginBottom: '1rem'
          }}>
            Experience &{' '}
            <span style={{
              background: 'linear-gradient(135deg, #96C7B9 0%, #7BB5A7 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Education
            </span>
          </h2>
        </div>

        {/* Tab Navigation */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '3rem'
        }}>
          <div style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '8px',
            padding: '0.25rem',
            border: '2px solid rgba(150, 199, 185, 0.3)',
            boxShadow: '0 4px 15px rgba(150, 199, 185, 0.1)'
          }}>
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.75rem 1.5rem',
                    backgroundColor: activeTab === tab.id ? '#96C7B9' : 'transparent',
                    color: activeTab === tab.id ? '#FFFFFF' : '#546C81',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    if (activeTab !== tab.id) {
                      e.target.style.backgroundColor = 'rgba(150, 199, 185, 0.1)';
                      e.target.style.color = '#2C3E50';
                    }
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseOut={(e) => {
                    if (activeTab !== tab.id) {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#546C81';
                    }
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  <Icon size={18} />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Content */}
        <div style={{
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          {activeTab === 'experience' && (
            <div>
              {experiences.map((exp, index) => (
                <TimelineItem key={exp.id} item={exp} type="experience" />
              ))}
            </div>
          )}

          {activeTab === 'education' && (
            <div>
              {education.map((edu, index) => (
                <TimelineItem key={edu.id} item={edu} type="education" />
              ))}
            </div>
          )}

          {activeTab === 'certifications' && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              {certifications.map((cert, index) => (
                <CertificationCard key={cert.id} cert={cert} />
              ))}
            </div>
          )}
        </div>

        {/* Resume Download CTA */}
        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <a
            href="https://drive.google.com/file/d/1ZbMNhKY4Z8zLsDf3B6D53_mus-2ojZBU/view?usp=sharing" // Updated resume download link
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '1rem 2rem',
              background: 'linear-gradient(135deg, #96C7B9 0%, #7BB5A7 100%)',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '1rem',
              fontWeight: '600',
              boxShadow: '0 4px 15px rgba(150, 199, 185, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'scale(1.05) translateY(-2px)';
              e.target.style.boxShadow = '0 8px 25px rgba(150, 199, 185, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'scale(1) translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(150, 199, 185, 0.3)';
            }}
          >
            <Download size={20} />
            Download Full Resume
          </a>
        </div>
      </div>
    </section>
  );
};

export default Experience;